import { Box, Divider, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Chip from '../../components/Chip/Chip';
import PageTitle from '../../components/PageTitle/PageTitle';
import { Project } from '../../models/project';
import { projectService } from '../../services/projectService';
import AcceptModal from './AcceptModal';
import DeclineModal from './DeclineModal';
import ProjectCard from './ProjectCard';

const Dashboard = (): JSX.Element => {
  const [projects, setProjects] = useState<Project[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [acceptModalData, setAcceptModalData] = useState<{
    open: boolean;
    project?: Project;
  }>({ open: false });
  const [declineModalData, setDeclineModalData] = useState<{
    open: boolean;
    project?: Project;
  }>({ open: false });

  const getProjects = () => {
    projectService.getProjectRequest().then((response) => {
      setProjects(response.data.content);
      setLoading(false);
    });
  };

  useEffect(() => {
    getProjects();
  }, []);

  const onAcceptProject = (
    event: React.MouseEvent<unknown>,
    project: Project
  ) => {
    event.stopPropagation();
    if (project?.id) {
      projectService.acceptProject(project.id).then(() => {
        getProjects();
        setAcceptModalData({ open: true, project });
      });
    }
  };

  const onDeclineProject = (
    event: React.MouseEvent<unknown>,
    project: Project
  ) => {
    event.stopPropagation();
    setDeclineModalData({ open: true, project });
  };

  const confirmDeclineProject = (declineReason: string) => {
    if (declineModalData.project?.id) {
      projectService
        .declineProject({
          projectId: declineModalData.project.id,
          declineReason
        })
        .then(() => {
          getProjects();
        });
    }
    setDeclineModalData({ open: false, project: undefined });
  };

  return (
    <>
      <Box display="flex" alignItems="center">
        <PageTitle>View All Project Requests</PageTitle>
        <Chip size={projects.length} />
      </Box>
      <Divider sx={{ mb: 3 }} />
      <Grid
        container
        spacing={2}
        sx={{ paddingLeft: '32px', paddingRight: '32px', marginBottom: '15px' }}
      >
        <Grid item xs={3}>
          <Typography variant="subtitle2">Project Request</Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography variant="subtitle2">Project Details</Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography variant="subtitle2">Project Budget</Typography>
        </Grid>
        <Grid item xs={2}>
          <Box display="flex" justifyContent="flex-end">
            <Typography variant="subtitle2">Request status</Typography>
          </Box>
        </Grid>
      </Grid>
      <Box>
        {projects.map((project) => (
          <ProjectCard
            project={project}
            key={project?.id}
            onAcceptProject={onAcceptProject}
            onDeclineProject={onDeclineProject}
          />
        ))}
      </Box>
      {!loading && !projects.length && (
        <Typography variant="h5" align="center" m={4}>
          No Projects found!
        </Typography>
      )}
      <AcceptModal
        modalData={acceptModalData}
        closeModal={() => setAcceptModalData({ open: false })}
      />
      <DeclineModal
        modalData={declineModalData}
        confirmModal={confirmDeclineProject}
        closeModal={() => setDeclineModalData({ open: false })}
      />
    </>
  );
};

export default Dashboard;
